<template>
  <div class="store">
    <div class="store-top" v-if="step == 1">
      <div class="store-top-left">
        <van-image
          class="avatarImg"
          :src="imgUrlFilter(userInfo.CompanyLogoPic)"
          @click="imagePreview(imgUrlFilter(userInfo.CompanyLogoPic))"
        />
      </div>
      <div class="store-top-right">
        <div class="store-info">
          {{ $t.store.companyName }}：{{ userInfo.CompanyName }}
        </div>
        <div class="store-info" style="margin-top: 10px">
          {{ $t.store.companyAccount }}：{{ userInfo.TotalAvailableQuantity }}
        </div>
      </div>
      <div class="store-title">{{ $t.store.remind }}：{{ userInfo.SurplusQuantity }}</div>
      <div class="store-title" v-if="userInfo.ValidityPeriodDate">
        {{ $t.store.vpDate }}：{{ userInfo.ValidityPeriodDate }}
        <span class="expire-text" v-if="isExpired()">( {{ $t.store.expire }} )</span>
      </div>
    </div>

    <div class="store-content" v-if="step == 1">
      <div v-if="unpaidLink">
        <div class="unpaid-text">{{ $t.store.unpaidText }}</div>
        <van-cell :title="$t.store.onPay" is-link @click="gotoConsumptionRecord" />
      </div>
      <div v-else>
        <div class="guide-text">{{ $t.store.guideText }}</div>
        <van-cell
          :title="option.name"
          is-link
          v-for="(option, index) in stepOptions"
          :key="index"
          :class="option.disabled ? 'disabled-text' : ''"
          @click="stepClick(option.value, option.disabled)"
        />
      </div>
    </div>

    <div class="store-content" v-if="step == 2">
      <van-form label-width="200px">
        <van-field
          name="stepper"
          :label="$t.store.accountNumber(prices.number)"
          label-class="accountNumber-label"
          readonly
          v-if="form.orderType != 3"
        >
          <template #right-icon>
            <van-stepper
              v-model="form.accountNumber"
              :min="0"
              :max="999"
              :step="5"
              @change="calculate"
            />
          </template>
        </van-field>

        <van-field
          :label="$t.store.accountLanguage(prices.language)"
          readonly
          v-if="form.orderType != 3"
        >
          <template #right-icon>
            <div v-if="contents.IsBuyChineseToEnglishFunction">
              {{ $t.store.isBuy }}
            </div>
            <van-checkbox
              v-else
              v-model="form.accountLanguage"
              @change="calculate"
            ></van-checkbox>
          </template>
        </van-field>

        <van-field
          :label="$t.store.accountWxMini(prices.wxmini)"
          readonly
          v-if="form.orderType != 3"
        >
          <template #right-icon>
            <div v-if="contents.IsBuyWeChatFunction">{{ $t.store.isBuy }}</div>
            <van-checkbox
              v-else
              v-model="form.accountWxMini"
              @change="calculate"
            ></van-checkbox>
          </template>
        </van-field>

        <div class="payCenter" v-if="form.orderType != 2">
          <div class="payCenter-label">{{ $t.store.validityDate }}</div>
          <div class="payCenter-selecter">
            <div
              :class="[
                form.accountValidity == item.Year ? 'selecter-selected-orange' : '',
                'selecter-option',
              ]"
              v-for="(item, index) in validityOptions"
              :key="index"
              @click="timeSelect(item.Year)"
            >
              <div class="selecter-year-label">{{ item.Year }}{{ $t.store.year }}</div>
              <div class="selecter-detail">
                {{ $t.store.cutoff }} {{ item.MaturityTime }}
              </div>
            </div>
          </div>
        </div>

        <div class="payCenter" v-if="form.orderType != 3">
          <div class="payCenter-label">{{ $t.store.menusLabel }}</div>
          <div class="payCenter-selecter">
            <div
              :class="[
                menu.onBuy || menu.disabled ? 'selecter-selected-blue' : '',
                'selecter-option',
              ]"
              v-for="(menu, index) in menuAllList"
              :key="index"
              @click="dialogShow(menu.id)"
            >
              <div
                class="selecter-label"
                :style="{ 'line-height': lang == 'zh' ? '34px' : 'normal' }"
              >
                {{ menu.text }}
              </div>
            </div>
          </div>
        </div>

        <van-field
          v-model="form.couponNumber"
          :label="$t.store.coupon"
          label-class="number-label"
          label-width="80px"
          :placeholder="$t.meta.input"
          style="padding-top: 20px"
        >
          <template #button>
            <van-button
              size="small"
              type="default"
              @click="initCoupon"
              v-if="form.couponId"
              >{{ $t.meta.cancel }}</van-button
            >
            <van-button size="small" type="info" @click="getCoupon" v-else>{{
              $t.meta.confirm
            }}</van-button>
          </template>
        </van-field>

        <div class="store-radio">
          <div class="radio-label">{{ $t.store.payCurrency }}</div>
          <van-radio-group
            v-model="form.payCurrency"
            @change="handleChange"
            :disabled="form.couponId ? true : false"
            direction="horizontal"
          >
            <van-radio
              v-for="(currency, index) in currencyOptions"
              :key="index"
              :name="currency.PCId"
              >{{ currency.CurrencySn }}</van-radio
            >
          </van-radio-group>
        </div>

        <div class="store-radio" v-if="form.payCurrency">
          <div class="radio-label">{{ $t.store.methods }}</div>
          <van-radio-group v-model="form.payMethod" direction="horizontal">
            <van-radio
              v-for="(pay, index) in payOptions"
              :key="index"
              :name="pay.value"
              >{{ pay.name }}</van-radio
            >
          </van-radio-group>
        </div>

        <van-field
          :value="(currency ? currency.CurrencySymbol : '') + totalAmount"
          input-align="right"
          :label="$t.store.totalAmount"
          class="amount-total1"
          readonly
        />
        <van-field
          :value="(currency ? currency.CurrencySymbol : '') + discountAmount"
          input-align="right"
          :label="$t.store.discountAmount"
          class="amount-total2"
          readonly
        />
        <van-field
          :value="(currency ? currency.CurrencySymbol : '') + payAmount"
          input-align="right"
          :label="$t.store.payAmount"
          class="amount-total3"
          readonly
        />

        <van-field :label="$t.store.agreementText" readonly required>
          <template #right-icon>
            <van-checkbox v-model="form.isAgree"></van-checkbox>
          </template>
        </van-field>
      </van-form>
      <van-button
        round
        block
        type="default"
        class="store-content-back"
        @click="stepBack"
        >{{ $t.store.back }}</van-button
      >
    </div>

    <van-popup
      v-model="dialogVisible"
      @close="dialogSubmit"
      position="bottom"
      :style="{ height: '70%' }"
    >
      <v-jstree
        :data="dialogData"
        size="large"
        show-checkbox
        multiple
        allow-batch
        whole-row
        @item-click="dialogDataClick"
      ></v-jstree>
    </van-popup>

    <div class="tool-bar" v-if="step == 2">
      <van-button type="info" block @click="handleSubmit">
        {{ $t.store.orderButton }}
      </van-button>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import { SET_AUTH } from "@/store/mutation-types";

import Vue from "vue";
import {
  Form,
  Field,
  Cell,
  Button,
  Icon,
  Image,
  Stepper,
  Switch,
  Popup,
  Checkbox,
  Radio,
  RadioGroup,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Cell)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Stepper)
  .use(Switch)
  .use(Popup)
  .use(Checkbox)
  .use(Radio)
  .use(RadioGroup);

export default {
  name: "store",
  data() {
    return {
      lang: localStorage.getItem("requestLanguage"),
      step: 1,
      unpaidLink: "",
      contents: {},
      userInfo: {},
      stepOptions: [
        {
          name: this.$t.store.stepOption1,
          value: "1",
          disabled: false,
        },
        {
          name: this.$t.store.stepOption2,
          value: "2",
          disabled: false,
        },
        {
          name: this.$t.store.stepOption3,
          value: "3",
          disabled: false,
        },
      ],
      payOptions: [],
      currencyOptions: [],
      currency: {},
      validityOptions: [],
      prices: {
        number: 0,
        language: 0,
        wxmini: 0,
        preferential: 0, //优惠率
        coupon: 0, //优惠卷金额
        trees: 0, //套餐价格
        rate: 1, //汇率
      },
      form: {},
      menuAllList: [], //全部菜单
      defaultMenu: [], //默认的菜单
      totalAmount: 0, //总费用
      discountAmount: 0, //优惠金额
      payAmount: 0, //应付金额
      dialogVisible: false,
      dialogData: [],
    };
  },
  created() {
    this.initData();
    this.getUserInfo();
    this.getUnpaidOrder();
  },
  methods: {
    ...mapMutations([SET_AUTH]),
    isExpired() {
      var currentDate = new Date();
      var vDate = this.userInfo.ValidityPeriodDate;
      var inputDate = new Date(vDate);

      if (inputDate < currentDate) {
        return true;
      } else {
        return false;
      }
    },
    reload() {
      this.initData();
      this.getUserInfo();
      this.getUnpaidOrder();
    },
    initData() {
      this.form = {
        orderType: 1,
        accountNumber: 0,
        accountLanguage: false,
        accountWxMini: false,
        accountValidity: 1,
        items1: [],
        items2: [],
        items3: [],
        disabledItems: [],
        couponNumber: "",
        couponId: "",
        payMethod: "1",
        payCurrency: "1",
        isAgree: false,
      };
    },
    initAmount() {
      this.discountAmount = 0;
      this.totalAmount = 0;
      this.payAmount = 0;
    },
    initCoupon() {
      this.form.couponNumber = "";
      this.form.couponId = "";
      this.prices.coupon = 0;
      this.discountAmount = 0;
      this.calculate();
    },
    initCurrency() {
      this.form.currencyOptions = "";
      this.currency = {};
      this.prices.rate = 1;
    },
    stepBack() {
      this.step = 1;
      this.getUserInfo();
      this.initData();
      this.initAmount();
      this.initCoupon();
      this.initCurrency();
    },
    stepClick(value, disabled) {
      if (disabled) {
        return;
      }
      this.form.orderType = value;
      this.step = 2;
      this.getCompanyOrderInfo();
      this.getCurrency();
      this.setRate();
    },
    timeSelect(value) {
      this.form.accountValidity = value;
      this.calculate();
    },
    getCompanyOrderInfo() {
      this.$commonMethod.showLoading();
      var param = { OrderType: this.form.orderType };
      this.$api.myHome
        .loadCompanyOrderInfo(param)
        .then((res) => {
          var data = res.data;
          if (data) {
            this.contents = data;
            this.menuAllList = this.formatData(data.ChargeMenuList); //套餐
            this.validityOptions = data.ValidityPeriodList; //有效期选项
            this.form.accountValidity = data.ValidityPeriod; //有效期id

            //中英切换
            this.form.accountLanguage = data.IsBuyChineseToEnglishFunction;
            this.prices.language =
              data.IsBuyChineseToEnglishFunction == 0
                ? data.PlatformFunctionCostList[0].UnitPrice
                : 0;

            //小程序
            this.form.accountWxMini = data.IsBuyWeChatFunction;
            this.prices.wxmini =
              data.IsBuyWeChatFunction == 0
                ? data.PlatformFunctionCostList[1].UnitPrice
                : 0;

            this.prices.number = data.PlatformFunctionCostList[2].UnitPrice; //账户价格
            this.prices.preferential = data.PreferentialRate; //优惠率
            //this.prices.preferential = 0.08;
            if (this.form.orderType == 1 || this.form.orderType == 3) {
              //开通功能和续费功能，初始化价格
              this.setDefaultPrices();
            }
            this.calculatePackage(); //计算套餐价格
            this.calculate(); //计算总价格
          }
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    setDefaultPrices() {
      var items1 = this.getDisabled(this.menuAllList).items1;
      var items2 = this.getDisabled(this.menuAllList).items2;
      var items3 = this.getDisabled(this.menuAllList).items3;
      this.form.disabledItems = [...items1, ...items2, ...items3];
    },
    calculatePackage() {
      this.$commonMethod.showLoading();
      var param = {
        SelectedMenuIdList: [
          ...this.form.items1,
          ...this.form.items2,
          ...this.form.items3,
          ...this.form.disabledItems,
        ],
      };
      this.$api.myHome
        .selectedMenuIdTotalAmount(param)
        .then((res) => {
          this.prices.trees = res.data;
          this.calculate();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    calculate() {
      this.initAmount();
      var othersPrice =
        this.form.accountNumber * this.prices.number +
        (this.form.accountLanguage ? this.prices.language : 0) +
        (this.form.accountWxMini ? this.prices.wxmini : 0); //账号数量，多语言，小程序费用
      this.totalAmount = (othersPrice + this.prices.trees) * this.form.accountValidity; //板块，有效期费用

      //计算汇率
      if (this.prices.rate) {
        this.totalAmount = this.totalAmount * this.prices.rate;
      }
      this.totalAmount = this.fiveRound(this.totalAmount, 2); //【总费用】

      var coupon = this.prices.coupon; //优惠券金额
      if (this.form.orderType == 2 && this.prices.preferential) {
        var preferential = this.totalAmount * this.prices.preferential; //优惠率，扩展功能才有
        this.discountAmount = this.discountAmount + preferential + coupon; //使用优惠率+优惠券
      } else {
        this.discountAmount = this.discountAmount + coupon; //使用优惠券
      }
      this.discountAmount = this.fiveRound(this.discountAmount, 2); //【优惠金额】

      //console.log(this.discountAmount);
      this.payAmount = this.totalAmount;
      this.payAmount = this.payAmount - this.discountAmount; //折后金额

      //优惠后低于0
      if (this.payAmount < 0) {
        this.payAmount = 0;
      }
      this.payAmount = this.fiveRound(this.payAmount, 2); //【应付金额】
    },
    getDisabled(node) {
      var items1 = [];
      var items2 = [];
      var items3 = [];
      node.forEach((item1) => {
        if (item1.disabled) {
          items1.push(item1.id);
          if (item1.children.length) {
            item1.children.forEach((item2) => {
              if (item2.disabled) {
                items2.push(item2.id);
                if (item2.children.length) {
                  item2.children.forEach((item3) => {
                    if (item3.disabled) items3.push(item3.id);
                  });
                }
              }
            });
          }
        }
      });
      return { items1: items1, items2: items2, items3: items3 };
    },
    dialogShow(menuId) {
      this.defaultMenu = [...this.form.items1, ...this.form.items2, ...this.form.items3];
      console.log("已选数据: " + this.defaultMenu);
      var keys = [...this.form.items1, ...this.form.items2, ...this.form.items3];
      console.log("弹窗数据：" + keys);
      for (var menu of this.menuAllList) {
        if (menu.id == menuId) {
          this.dialogData = this.$commonMethod.deepClone(
            this.formatDialogData([menu], keys)
          );
          break;
        }
      }
      this.dialogVisible = true;
    },
    dialogSubmit() {
      var keys = this.getLeafKeys(this.dialogData);
      console.log("添加数据: " + JSON.stringify(keys));
      //删除去掉的菜单
      this.onRemoveMenus();
      if (keys.length > 0) {
        //判断主菜单样式
        this.onCheckMenus(true);
      } else {
        this.onCheckMenus(false);
      }
      this.onAddMenus(keys);
      this.dialogVisible = false;
      this.calculatePackage();
    },
    onCheckMenus(check) {
      for (const menu of this.menuAllList) {
        if (menu.id == this.dialogData[0].id) {
          menu.onBuy = check;
          break;
        }
      }
    },
    onAddMenus(keys) {
      var items1 = [];
      var items2 = [];
      var items3 = [];
      for (var key of keys) {
        if (
          this.form.items1.find((id) => id == key) ||
          this.form.items2.find((id) => id == key) ||
          this.form.items3.find((id) => id == key)
        ) {
          //相同的id不暂存
        } else {
          let data = this.getMenuIdByKey(this.dialogData, key);
          if (data.type == 1) items1.push(data.id);
          if (data.type == 2) items2.push(data.id);
          if (data.type == 3) items3.push(data.id);
        }
      }
      if (items1.length) this.form.items1 = this.form.items1.concat(items1);
      if (items2.length) this.form.items2 = this.form.items2.concat(items2);
      if (items3.length) this.form.items3 = this.form.items3.concat(items3);
    },
    onRemoveMenus() {
      var changeItems1 = this.getMenuIdByKeys(this.dialogData, this.defaultMenu).items1;
      var changeItems2 = this.getMenuIdByKeys(this.dialogData, this.defaultMenu).items2;
      var changeItems3 = this.getMenuIdByKeys(this.dialogData, this.defaultMenu).items3;
      var items1 = this.form.items1;
      var items2 = this.form.items2;
      var items3 = this.form.items3;

      for (let i = 0; i < items1.length; i++) {
        for (var item of changeItems1) {
          if (item == items1[i]) {
            items1.splice(i, 1);
          }
        }
      }
      this.form.items1 = items1;

      for (let i = 0; i < items2.length; i++) {
        for (const item of changeItems2) {
          if (item == items2[i]) {
            items2.splice(i, 1);
          }
        }
      }
      this.form.items2 = items2;

      for (let i = 0; i < items3.length; i++) {
        for (const item of changeItems3) {
          if (item == items3[i]) {
            items3.splice(i, 1);
          }
        }
      }
      this.form.items3 = items3;

      console.log("items1,需要删除的数据: " + changeItems1);
      console.log("items2,需要删除的数据: " + changeItems2);
      console.log("items3,需要删除的数据: " + changeItems3);
    },
    handleSubmit() {
      console.log("items1: " + this.form.items1);
      console.log("items2: " + this.form.items2);
      console.log("items3: " + this.form.items3);
      console.log("disabledItems: " + this.form.disabledItems);
      var param = {
        C_AllOrderNumber: this.contents.C_AllOrderNumber,
        OrderType: this.form.orderType,
        PurchasedExtendedQuantity: this.form.accountNumber,
        ValidityPeriod: this.form.accountValidity,
        IsBuyChineseToEnglishFunction: this.form.accountLanguage,
        IsBuyWeChatFunction: this.form.accountWxMini,
        SetMealId: 0,
        UseCouponsId: this.form.couponId,
        PreferentialRate: this.prices.preferential,
        DiscountAmount: this.discountAmount,
        OrderTotalAmount: this.totalAmount,
        PayAmount: this.payAmount,
        PaymentType: this.form.payMethod,
        SelectedMenuIdList: [
          ...this.form.items1,
          ...this.form.items2,
          ...this.form.items3,
          ...this.form.disabledItems,
        ],
        PCId: this.form.payCurrency,
        ConversionRate: this.prices.rate,
      };
      if (!this.form.isAgree) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg: this.$t.store.ruleIsAgree,
        });
        return;
      }
      this.$commonMethod.showLoading();
      this.$api.user
        .addCompanyOrder(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          var orderNumber = res.data;
          if (this.payAmount == 0) {
            this.gotoConsumptionRecord();
          } else {
            this.generatePayment(orderNumber);
          }
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    generatePayment(orderNumber) {
      this.$commonMethod.showLoading();
      var param = {
        C_OrderNumber: orderNumber,
      };
      this.$api.user
        .generatePaymentLink(param)
        .then(() => {
          this.gotoConsumptionRecord();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getMenuIdByKey(node, key) {
      var data = {};
      node.forEach((item1) => {
        if (item1.id == key && !item1.disabled) {
          data.id = item1.id;
          data.type = 1;
        } else {
          if (item1.children.length) {
            item1.children.forEach((item2) => {
              if (item2.id == key && !item2.disabled) {
                data.id = item2.id;
                data.type = 2;
              } else {
                if (item2.children.length) {
                  item2.children.forEach((item3) => {
                    if (item3.id == key && !item3.disabled) {
                      data.id = item3.id;
                      data.type = 3;
                    }
                  });
                }
              }
            });
          }
        }
      });
      return data;
    },
    getMenuIdByKeys(node, keys) {
      var items1 = [];
      var items2 = [];
      var items3 = [];
      node.forEach((item1) => {
        if (keys.find((id) => id == item1.id)) {
          if (!item1.disabled) items1.push(item1.id);
        }
        if (item1.children.length) {
          item1.children.forEach((item2) => {
            if (keys.find((id) => id == item2.id)) {
              if (!item2.disabled) items2.push(item2.id);
            }
            if (item2.children.length) {
              item2.children.forEach((item3) => {
                if (keys.find((id) => id == item3.id)) {
                  if (!item3.disabled) items3.push(item3.id);
                }
              });
            }
          });
        }
      });
      return { items1: items1, items2: items2, items3: items3 };
    },
    handleChange(PCId) {
      this.setCurrency();
      this.setRate(PCId);
      this.calculate();
    },
    setCurrency() {
      if (this.form.payCurrency == 1) {
        this.payOptions = [
          {
            name: this.$t.store.paymentOption1,
            value: "1",
          },
          {
            name: this.$t.store.paymentOption2,
            value: "2",
          },
        ];
        this.form.payMethod = "1";
      } else {
        this.payOptions = [
          {
            name: this.$t.store.paymentOption3,
            value: "3",
          },
        ];
        this.form.payMethod = "3";
      }
    },
    setRate(PCId) {
      this.currency = this.currencyOptions.find((item) => item.PCId == PCId);
      if (this.currency && this.currency.ConversionRate) {
        this.prices.rate = this.currency.ConversionRate;
        this.prices.rate = parseFloat(this.prices.rate);
      }
    },
    getCurrency() {
      this.$commonMethod.showLoading();
      var param = {};
      this.$api.myHome
        .getSystemPaymentCurrencyConfigList(param)
        .then((res) => {
          var data = res.data;
          if (data) {
            this.currencyOptions = data;
            this.setRate(this.currencyOptions[0].PCId);
            this.payOptions = [
              {
                name: this.$t.store.paymentOption1,
                value: "1",
              },
              {
                name: this.$t.store.paymentOption2,
                value: "2",
              },
            ];
          }
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getCoupon() {
      this.$commonMethod.showLoading();
      var param = {
        CouponNumber: this.form.couponNumber,
      };
      this.$api.myHome
        .getCouponAmountByCouponNumber(param)
        .then((res) => {
          var data = res.data;
          if (data) {
            this.form.couponId = data.CouponId;
            this.prices.coupon = data.CouponAmount;
            var PCId = data.PCId.toString();
            this.form.payCurrency = PCId;
            this.setCurrency();
            this.setRate(PCId);
            this.calculate();
          }
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getUnpaidOrder() {
      this.$commonMethod.showLoading();
      var param = {};
      this.$api.user
        .loadCurrentUnpaidOrder(param)
        .then((res) => {
          var data = res.data;
          if (data) {
            this.unpaidLink = data;
          }
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getUserInfo() {
      this.$commonMethod.showLoading();
      var param = {
        UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      };
      this.$api.myHome
        .getUserInfo(param)
        .then((res) => {
          this.userInfo = res.data;
          for (var option of this.stepOptions) {
            if (option.value == 1) {
              if (this.userInfo.ValidityPeriodDate) {
                option.disabled = true;
              } else {
                option.disabled = false;
              }
            } else {
              if (this.userInfo.ValidityPeriodDate) {
                option.disabled = false;
              } else {
                option.disabled = true;
              }
            }
          }
          this.SET_AUTH(res.data);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    gotoConsumptionRecord() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "consumptionRecord",
        name: "consumptionRecord",
        query: [],
      });
    },
    fiveRound(num, fixed) {
      var pos = num.toString().indexOf("."),
        decimal_places = num.toString().length - pos - 1,
        _int = num * Math.pow(10, decimal_places),
        divisor_1 = Math.pow(10, decimal_places - fixed),
        divisor_2 = Math.pow(10, fixed);
      return Math.round(_int / divisor_1) / divisor_2;
    },
    getLeafKeys(node) {
      var result = [];
      node.forEach((item1) => {
        if (result.find((id) => id == item1.id)) {
        } else {
          if (item1.selected && !item1.disabled) result.push(item1.id);
        }
        if (item1.children.length) {
          item1.children.forEach((item2) => {
            if (result.find((id) => id == item2.id)) {
            } else {
              if (item2.selected && !item2.disabled) result.push(item2.id);
            }
            if (item2.children.length) {
              item2.children.forEach((item3) => {
                if (result.find((id) => id == item3.id)) {
                } else {
                  if (item3.selected && !item3.disabled) result.push(item3.id);
                }
              });
            }
          });
        }
      });
      return result;
    },
    formatDialogData(arr, keys) {
      var result = arr;
      result.forEach((item1) => {
        if (keys.find((id) => id == item1.id) && item1.disabled == false) {
          item1.selected = true;
        } else {
          item1.selected = false;
        }
        if (item1.children.length) {
          for (var item2 of item1.children) {
            if (keys.find((id) => id == item2.id && item2.disabled == false)) {
              item2.selected = true;
            } else {
              item2.selected = false;
            }
            if (item2.children.length) {
              for (var item3 of item2.children) {
                if (keys.find((id) => id == item3.id && item3.disabled == false)) {
                  item3.selected = true;
                } else {
                  item3.selected = false;
                }
              }
            }
          }
        }
      });
      return result;
    },
    formatData(arr) {
      var getText = (item) => {
        if (this.lang == "en") {
          return item.MenuNameEn;
        } else if (this.lang == "ar") {
          return item.MenuNameAr;
        } else {
          return item.MenuName;
        }
      };
      var result = arr;
      result.forEach((item1) => {
        item1.text = getText(item1);
        item1.id = item1.MenuId;
        item1.selected = item1.IsChecked == 1 ? true : false;
        item1.disabled = item1.disabled == 1 ? true : false;
        item1.icon = item1.disabled == 1 ? "fa-check" : "fa-default";
        item1.opened = true;
        item1.children = [];
        if (item1.ChildMenuList.length) {
          item1.children = item1.ChildMenuList;
          for (var item2 of item1.ChildMenuList) {
            item2.text = getText(item2);
            item2.id = item2.MenuId;
            item2.selected = item2.IsChecked == 1 ? true : false;
            item2.disabled = item2.disabled == 1 ? true : false;
            item2.icon = item2.disabled == 1 ? "fa-check" : "fa-default";
            item2.opened = true;
            item2.children = [];
            if (item2.ChildMenuList.length) {
              item2.children = item2.ChildMenuList;
              for (var item3 of item2.ChildMenuList) {
                item3.text = getText(item3);
                item3.id = item3.MenuId;
                item3.selected = item3.IsChecked == 1 ? true : false;
                item3.disabled = item3.disabled == 1 ? true : false;
                item3.icon = item3.disabled == 1 ? "fa-check" : "fa-default";
              }
            }
          }
        }
      });
      return result;
    },
    dialogDataClick(node) {
      var onSelect = (data) => {
        var count = 0;
        var childs = data.children;
        for (var child of childs) {
          if (child.selected) {
            count = count + 1;
          }
        }
        if (count > 0) {
          if (!data.disabled) data.selected = true;
        } else {
          data.selected = false;
        }
      };
      var parent = node.$parent.model; //上一级节点
      if (parent) {
        onSelect(parent);
      }
      var grandpa = node.$parent.$parent.model; //上上级节点
      if (grandpa) {
        onSelect(grandpa);
      }
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.store {
  ::v-deep .fa-default {
    display: none;
  }
  ::v-deep .fa-check {
    background-image: url("~assets/img/home/icon_checkbox_select.png");
    background-size: 20px;
    background-repeat: no-repeat;
    background-position: center;
  }
  ::v-deep .tree-anchor {
    width: 100%;
    font-size: 16px;
  }
  ::v-deep .tree-wholerow {
    background: #ffffff;
  }
  ::v-deep .tree-wholerow-clicked {
    background: #e5e5e5 !important;
  }
  ::v-deep .tree-disabled {
    background: transparent !important;
    .tree-checkbox {
      display: none !important;
    }
  }
  ::v-deep .number-label {
    line-height: 33px;
  }
  ::v-deep .accountNumber-label {
    margin-top: 2px;
  }
  ::v-deep .amount-total1 {
    input {
      color: #999;
    }
  }
  ::v-deep .amount-total2 {
    input {
      color: #777;
    }
  }
  ::v-deep .amount-total3 {
    input {
      color: orange;
      font-size: 18px;
    }
  }
  .store-top {
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebedf0;
    .store-top-left {
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      width: 30%;
      .avatarImg {
        width: 80px;
        height: 80px;
        .userImg {
          width: 80px;
          height: 80px;
          object-fit: contain;
          border-radius: 100%;
        }
        ::v-deep .van-image__error {
          border-radius: 100%;
          position: block;
        }
        ::v-deep .van-image__img {
          object-fit: contain;
          border-radius: 100px;
        }
      }
    }
    .store-top-right {
      display: inline-block;
      vertical-align: middle;
      width: 70%;
      .store-info {
        font-size: 14px;
        color: #666;
      }
    }
    .store-title {
      font-size: 14px;
      padding-top: 10px;
      padding-left: 20px;
      color: #666;
      .expire-text {
        color: red;
      }
    }
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .store-content {
    .store-content-back {
      margin: 10px auto;
      width: 90%;
      ::v-deep .van-button__text {
        font-size: 16px !important;
      }
    }
    .unpaid-text {
      width: 100%;
      padding: 20px 0px;
      text-align: center;
      color: red;
      font-size: 14px;
      border-bottom: 1px solid #ebedf0;
    }
    .guide-text {
      width: 100%;
      padding: 20px 0px;
      text-align: center;
      color: #1890ff;
      font-size: 14px;
      border-bottom: 1px solid #ebedf0;
    }
    .disabled-text {
      .van-cell__title {
        color: #969799;
      }
    }
    .payCenter {
      padding-top: 20px;
      .payCenter-label {
        color: #646566;
        font-size: 14px;
        padding-left: 20px;
      }
      .payCenter-selecter {
        .selecter-selected-orange {
          border: 2px solid orange !important;
        }
        .selecter-selected-blue {
          border: 2px solid #1890ff !important;
        }
        .selecter-option {
          vertical-align: top;
          display: inline-block;
          border: 2px solid #e5e5e5;
          padding: 10px 20px;
          margin-top: 20px;
          margin-left: 5.5%;
          width: 30%;
          text-align: center;
          .selecter-year-label {
            font-size: 14px;
            font-weight: bold;
          }
          .selecter-label {
            font-size: 14px;
            font-weight: bold;
            min-height: 34px;
          }
          .selecter-detail {
            margin-top: 5px;
            font-size: 10px;
            color: #999;
          }
        }
      }
    }
    .store-radio {
      padding: 20px;
      border-bottom: 1px solid #ebedf0;
      .radio-label {
        color: #646566;
        margin-bottom: 20px;
        font-size: 14px;
      }
      .van-radio {
        margin-right: 20px;
        margin-bottom: 10px;
        font-size: 14px;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
